import * as React from "react";
import { useQuery } from "@tanstack/react-query";
import CompleteScreen from "../../components/layout/reservation/CompleteScreen";
import { usePayInfo } from "../../@apis/hooks/usePay";
import { useNavigate, useParams } from "react-router-dom";
import FailScreen from "../../components/layout/reservation/FailScreen";
import { useModalStore } from "../../lib/store/useModalStore";

export default function PaymentCompletePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { openModal } = useModalStore();

  React.useEffect(() => {
    const original = window.closeDialogIfOpened;
    window.closeDialogIfOpened = () => {
      const modals = useModalStore.getState().modals;
      if (modals.length > 0) {
        useModalStore.getState().closeModal(modals[modals.length - 1].id);
        return true;
      }
      openModal("CONFIRM_DIALOG", {
        title: "홈으로 이동",
        content: "결제 후에는 뒤로 가실 수 없습니다.\n홈 화면으로 이동하시겠습니까?",
        onClick: () => navigate("/"),
      });
      return true;
    };
    return () => { window.closeDialogIfOpened = original; };
  }, []);
  const { data: payInfo } = useQuery({
      ...usePayInfo(id as string),
      enabled: !!id && id !== "null",
  });
  const payData = payInfo?.data;

  return (
    <>
      {payData?.isPaymentSucceed ? <CompleteScreen item={payData} /> : <FailScreen message={payData?.message || ""} />}
    </>
  )
}